import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FlowExplorer from '@/components/feature/FlowExplorer';
import { dataFlywheel } from '@/mocks/jiuchou-ai';

export default function DataFlywheel() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="数据闭环"
            title="九畴云铺的数据飞轮"
            subtitle="商品、交易、消费、用户、服务、产业数据汇聚，经 AI 分析、需求预测、供应链与商品优化，驱动再次交易。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12">
            <FlowExplorer steps={dataFlywheel} direction="horizontal" accent="primary" />
          </div>
        </Reveal>

        <Reveal delay={150}>
          <div className="mt-8 text-center">
            <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium">
              <i className="ri-loop-left-line text-primary-300"></i>
              数据不是终点，而是下一次交易的起点。
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}